import React, { FunctionComponent, useState } from "react";
import { IShelf } from "../../../hooks/shelves";
import styles from "./styles.module.scss";
import { IShelfSegment } from "../../../hooks/shelfSegments";
import { IShelving } from "../../../hooks/shelvings";
import { useTheme } from "@mui/material";
import classNames from "classnames";
import { ToolbarButton } from "../../toolbar/ToolbarButton";
import { IconType } from "../../../icons";
import { strings } from "../../../localization/LocalizedStrings";
import { ShelfSegmentStatsDialog } from "../ShelfSegmentStatsDialog";

export const LayoutStatsButton: FunctionComponent<ILayoutStatsButtonProps> = ({
  className,
  shelving,
  shelf,
  shelfSegment
}) => {
  const theme = useTheme();
  const [isStatsDialogOpen, setIsStatsDialogOpen] = useState(false);
  return (
    <div>
      <ToolbarButton
        className={classNames(className, styles.statsBox)}
        style={{
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.background.default
        }}
        tooltip={strings.option_stats}
        loading={shelving === undefined}
        iconType={IconType.AreaChart}
        onClick={() => setIsStatsDialogOpen(true)}
      />
      <ShelfSegmentStatsDialog
        open={isStatsDialogOpen}
        setOpen={setIsStatsDialogOpen}
        shelfSegment={shelfSegment}
        shelf={shelf}
        shelving={shelving}
      />
    </div>
  );
};

export interface ILayoutStatsButtonProps {
  className?: string;
  shelving: IShelving | undefined;
  shelf: IShelf | undefined;
  shelfSegment: IShelfSegment | undefined;
}
